import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  RoleToggleContainer,
} from './EmployeeAccountPanel.styles';
import {
  ActionMenuContainer,
  ActionMenuOptionContainer,
  IconAndTextContainer,
  StyledIconForward,
} from '../UserAccountPanel/UserAccountPanel.styles';
import { Typography } from '@mui/material';
import { EMPLOYEE_ACCOUNT_PANEL_OPTIONS_MENU } from './EmployeeAccountPanel.constants';
import { selectCurrentRole } from '../../../redux/slices/currentUserSlice';
import { getEmployeeClaims } from '../../../redux/people/peopleThunks';
import { selectUserRoles } from '../../../redux/people/peopleSlice';
import { updateUserRole } from '../../../utils/helpers/roleUtils';
import { ROLES } from '../../../utils/constants/roles';
import EmployeeInfo from '../../EmployeeInfo/EmployeeInfo';
import { DrawerContentContainer } from '../../AdminDrawer/AdminDrawer.styles';
import { showSuccessToast } from '../../../utils/toastUtils';
import RoleToggle from './components/RoleToggle';

const EmployeeAccountPanel = ({ employee, handleOpenDrawer }) => {
  const dispatch = useDispatch();
  const userClaims = useSelector(selectUserRoles);
  const currentUserRole = useSelector(selectCurrentRole);
  const isCurrentUserOwner = currentUserRole === ROLES.OWNER;

  const handleRoleChange = async (isOwner) => {
    await updateUserRole(employee, isOwner ? ROLES.OWNER : ROLES.EMPLOYEE, employee.vid);

    // We refetch user claims to make effective the UI state
    dispatch(getEmployeeClaims({ venueId: employee.vid, userId: employee.uid }))

    if (isOwner) {
      showSuccessToast(`${employee.displayName} is now an Owner on this Venue`);
    } else {
      showSuccessToast(`${employee.displayName} is no longer an Owner on this Venue`);
    }
  };

  useEffect(() => {
    dispatch(getEmployeeClaims({ venueId: employee.vid, userId: employee.uid }))
  }, [dispatch, employee.uid, employee.vid]);

  return (
    <DrawerContentContainer alignment="center">
      <EmployeeInfo employee={employee} headerType="name" />
      {isCurrentUserOwner && (
        <RoleToggleContainer>
          <RoleToggle userClaims={userClaims} onRoleToggle={handleRoleChange} />
        </RoleToggleContainer>
      )}
      <ActionMenuContainer>
        {EMPLOYEE_ACCOUNT_PANEL_OPTIONS_MENU.map((option, index) => (
          <ActionMenuOptionContainer
            key={`main-option-${index}`}
            isLast={index === EMPLOYEE_ACCOUNT_PANEL_OPTIONS_MENU.length - 1}
            onClick={() => handleOpenDrawer(option.handlerId, employee)}
          >
            <IconAndTextContainer>
              <option.icon />
              <Typography variant="bodyRegular">{option.title}</Typography>
            </IconAndTextContainer>
            <StyledIconForward />
          </ActionMenuOptionContainer>
        ))}
      </ActionMenuContainer>
    </DrawerContentContainer>
  );
};

export default EmployeeAccountPanel;
